"use client";
import { useQuery } from "@tanstack/react-query";
import { publicSettingsQuery } from "./art-catalogue-enabled";

/** `cashbackEnabled` from GET /setting/public. FALSE while loading or on error. */
export function useCashbackEnabled(): boolean {
  const { data } = useQuery(publicSettingsQuery);
  return data?.cashbackEnabled === true;
}
